import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Widget from '../Widget';
import Avatar from '../Avatar';
import WidgetTable from './Shared/WidgetTable';

export default class DiscussionActivityWidget extends Component {
  static propTypes = {
    seeMoreUrl: PropTypes.string.isRequired,
  };

  // Render Main screen using the data from `run_query`

  renderMainScreen(data) {
    return (
      <WidgetTable
        headerRow={
          <tr>
            <th>AUTHOR</th>
            <th>DISCUSSION</th>
            <th>
              <i className="Icon-comment" />
            </th>
            <th>
              <i className="Icon-favorite" />
            </th>
            <th>ACTIVITY</th>
          </tr>
        }
        dataRows={data.map(item => this.renderRow(item))}
        seeMoreUrl={this.props.seeMoreUrl}
      />
    );
  }

  renderRow(item) {
    return (
      <tr key={item.id}>
        <td>{this.renderAuthor(item.user, item.user_staff_path)}</td>
        <td>{this.renderTitle(item)}</td>
        <td className="u-w-6">{item.comments_count}</td>
        <td className="u-w-6">{item.votes_count}</td>
        <td>{item.relative_last_activity_date}</td>
      </tr>
    );
  }

  renderTitle(item) {
    return (
      <div className="u-w-48 u-truncate">
        <a href={item.public_path} target="_blank" rel="noopener noreferrer">
          {item.title}
        </a>
      </div>
    );
  }

  renderAuthor(author, authorPath) {
    return (
      <div className="u-flex u-items-center u-w-32">
        {this.renderAvatar(author)}
        <span className="u-min-w-0 u-truncate">
          <a href={authorPath}>{author.full_name}</a>
        </span>
      </div>
    );
  }

  renderAvatar(user) {
    return (
      <Avatar
        src={user.avatar.url}
        name={user.full_name}
        className="u-h-6 u-w-6 u-mr-2 u-flex-shrink-0"
      />
    );
  }

  // Render Configuration screen

  renderConfigurationScreen(configs, updateConfigState) {
    return (
      <span>
        <div className="widget-configs-label">Sort by</div>
        {this.renderSortOption(
          configs,
          updateConfigState,
          'activity',
          'Discussions with recent activity'
        )}
        {this.renderSortOption(configs, updateConfigState, 'most_comments', 'Most commented')}
        {this.renderSortOption(configs, updateConfigState, 'least_comments', 'Least commented')}
        {this.renderSortOption(configs, updateConfigState, 'most_favorites', 'Most favorited')}
        {this.renderSortOption(configs, updateConfigState, 'least_favorites', 'Least favorited')}
      </span>
    );
  }

  renderSortOption(configs, updateConfigState, direction, label) {
    const inputName = `sort_by_${direction}`;
    return (
      <div className="radio">
        <label htmlFor={inputName}>
          <input
            type="radio"
            name={inputName}
            id={inputName}
            onChange={this.changeSortBy.bind(this, updateConfigState, direction)}
            checked={configs.sort_by === direction}
          />{' '}
          {label}
        </label>
      </div>
    );
  }

  changeSortBy(updateConfigState, newDirection) {
    updateConfigState({ sort_by: newDirection });
  }

  render() {
    return (
      <Widget
        renderMainScreen={this.renderMainScreen.bind(this)}
        renderConfigurationScreen={this.renderConfigurationScreen.bind(this)}
        {...this.props}
      />
    );
  }
}
